import { heroStats } from '@/mocks/animeData';

export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium mb-5">
              🔥 动漫爱好者都在用
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[52px] leading-tight text-foreground-950 mb-4">
              51动漫 - 海量韩漫日漫国漫免费全集 · 追更下拉式阅读平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-body mb-3">
              每日更新，精彩不停，追更从未如此简单
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-6">
              51动漫是国内领先的动漫内容聚合平台，覆盖韩漫、日漫、国漫三大板块，
              累计收录超 12000 部作品。从热血战斗到甜蜜恋爱，从悬疑推理到搞笑日常，
              无论是 JUMP 系经典还是小众佳作，这里都能找到你的心头好。
              支持独创下拉式阅读模式，纵向无缝衔接，追更体验流畅到飞起。
              当前热门：《咒术回战》最终章、《我独自升级》第二季、《鬼灭之刃》无限城篇正在火热连载中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                立即探索
              </a>
              <a
                href="#app"
                onClick={(e) => handleScroll(e, '#app')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-secondary-300 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] sm:w-[340px] sm:h-[340px] md:w-[420px] md:h-[420px] lg:w-[480px] lg:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20featuring%20multiple%20popular%20anime%20character%20silhouettes%20in%20dynamic%20action%20poses%2C%20warm%20coral%20red%20and%20golden%20amber%20color%20palette%2C%20Japanese%20manga%20panel%20layout%20elements%2C%20energy%20speed%20lines%2C%20glowing%20particles%2C%20cinematic%20composition%2C%20clean%20gradient%20background%20with%20subtle%20cherry%20blossom%20petals%2C%20modern%20flat%20illustration%20style&width=960&height=960&seq=hero-main-visual&orientation=squarish"
                alt="51动漫 - 海量动漫作品合集主视觉"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}